import {Component, Fragment} from 'react';
import { debounce } from 'throttle-debounce';
import { ConnectedProps, connect } from 'react-redux';
import { doSetIsMobile, doSetWindowDims } from './store/actions/system';
import { RootState } from './store/reducers/persistedReducer';

import NotFound from './StaticPages/NotFound';
import MainController from './controllers/MainController';
import AuthController from './controllers/AuthController';
import LoadScreen from './LoadScreen/LoadScreen';
import Modal from './Modal/Modal';
import AppError from './AppError/AppError';

import classnames from 'classnames';
import styles from './App.module.scss';

import '@cluster/web-components/dist/styles.css';

class App extends Component<PropsFromRedux> {

  componentDidMount() {
    // Add event listener
    this.resizeOps();
    window.addEventListener("resize", debounce(200, this.resizeOps.bind(this)));
    window.addEventListener("orientationchange", debounce(200, this.resizeOps.bind(this)));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", debounce(200, this.resizeOps.bind(this)));
    window.removeEventListener("orientationchange", debounce(200, this.resizeOps.bind(this)));
  }

  resizeOps = () => {
    // Set Mobile bool
    let isMobile = !window.matchMedia("(min-width: 760px)").matches;
    this.props.doSetIsMobile(isMobile);

    // Adjust vh styles for browser chrome bug fixes
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // Set window dimensions to store.
    this.props.doSetWindowDims({
      w: window.innerWidth,
      h: window.innerHeight
    })
  }

  render() {
    const rootComponents: {[index: string]: any} = {
      MainController,
      AuthController,
      LoadScreen,
      NotFound,
    }

    const PageComponent = rootComponents[this.props.controller]??Fragment;

    return (
      <div className={classnames(styles.App, styles["App_"+this.props.theme])}>
        <AppError>
          <PageComponent />
          <Modal />
        </AppError>
      </div>
    );
  }
}

const mapState = (state: RootState) => {
  return {
    theme: state.system.theme,
    isMobile: state.system.isMobile,
    controller: state.page.controller,
  }
}

const mapDispatch = {
  doSetIsMobile,
  doSetWindowDims
}

const connector = connect(
  mapState,
  mapDispatch
)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(App);
